// The label for ONE use case's Clay-attributed figure. A revenue use case is "Clay-attributed
// revenue", a cost use case (Tool consolidation, GTM automation) "Clay-attributed cost savings"; it
// follows the catalog's `outcome`, never a hardcoded id. A TOTAL across a mixed set of use cases
// keeps TOTAL_ATTRIBUTED_LABEL (ROI headline, deck hero, rollups).

import { getSizedUseCase, type LaggingOutcome } from '../../data/use-case-catalog';

export const TOTAL_ATTRIBUTED_LABEL = 'Clay-attributed value';

const BY_OUTCOME: Record<LaggingOutcome, string> = {
  revenue: 'Clay-attributed revenue',
  cost: 'Clay-attributed cost savings',
};

export function attributedLabelFor(outcome: LaggingOutcome): string {
  return BY_OUTCOME[outcome];
}

/** By use case id; an id the catalog no longer sizes (a retired lever) falls back to the total label. */
export function attributedLabelOf(useCaseId: string): string {
  const uc = getSizedUseCase(useCaseId);
  return uc ? attributedLabelFor(uc.outcome) : TOTAL_ATTRIBUTED_LABEL;
}
